<template>
  <div class="container --container-80">
    <!-- <TransitionGroup name="fade">  
    <PlanSelect
          :selected="another.current_plan"
          :selectList="['dsadsadsadad','dsadsadsadad','dsadsadsadad']"
          :key="'plan select'"
          @change="(plan) => another.current_plan = plan"
      />
    </TransitionGroup> -->
    <div class="car-info__top">
      <div class="car-info__col">
        <h2 class="car-info__name">{{ cardDetails.car_name }} <span class="text-gray">{{cardDetails.car_year}}</span></h2>
        <img class="car-info__icon-car" :src="cardDetails.car_images_one" />
        <div class="car-info__reviews">
          <Rating v-if="carStatus.stars.length"
              :stars="carStatus.stars.length"
              :languageEng="languageEng"
          />
          <span class="count-reviews">{{ cardReviews.length }}{{languageEng ? ' Review(s)' : ' Отзыв(a)'}}</span>
        </div>
        <h3 class="definition__title">{{ languageEng ? 'Description' : 'Описание' }}</h3>
        <p>{{languageEng ? cardDetails.car_description_eng : cardDetails.car_description}}</p>
      </div>
      <div class="car-info__col__block">
        <div class="car-info__col">
          <div class="date_select col">
            <SelectMiniatureWithTitleCalendar
                :name="'trip_start'"
                :value="another.trip_start" 
                :v-model="another.trip_start" 
                :title="languageEng ? 'Trip start' : 'Дата начала аренды'"
                @change="changeDate"
                valueCalendare="start"
                :languageEng="languageEng"
            />
            <SelectMiniatureWithTitleCalendar
                :name="'trip_end'"
                :value="another.trip_end" 
                v-model="another.trip_end"
                :title="languageEng ? 'Trip end' : 'Дата окончания аренды'"
                @change="changeDate"
                valueCalendare="end"
                :languageEng="languageEng"
            />
          </div>
        </div>
        <div class="car-info__col between">
          <div class="car-info__price" v-if="rent_day">
            <span class="car-info__value">${{cardDetails.car_price_one}}</span>
            <span class="car-info__definition">{{ languageEng ? 'per day' : 'в день'}}</span>
          </div>
          <div class="car-info__price" v-else-if="rent_weeks">
            <span class="car-info__value">${{cardDetails.car_price_two}}</span>
            <span class="car-info__definition">{{ languageEng ? 'per day' : 'в день'}}</span>
          </div>
          <div class="car-info__price" v-else-if="rent_mouth">
            <span class="car-info__value">${{cardDetails.car_price_three}}</span>
            <span class="car-info__definition">{{ languageEng ? 'per day' : 'в день'}}</span>
          </div>
          <div class="car-info__block" v-else-if="bad_date">
            <span class="car-info__value car-info__value--small">{{ languageEng ? 'Incorrect date' : 'Неверно указана дата'}}</span>
          </div>
          <div v-else class="car-info__block">
            <span class="car-info__value car-info__value--small">{{languageEng ? 'Set date' : 'Выберите дату'}}</span>
          </div>
          <button
            class="button button-car" :class="disabledButton ? 'button-car-disabled' : ''"
            :disabled="disabledButton"
            @click="rentAuto"
          >{{ languageEng ? 'Rent' : 'Арендовать'}}</button>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="section car-info__bottom --s-with-line">
      <Overview
          :languageEng="languageEng" :data="{car_color_s: cardDetails.car_color_s, car_color_v: cardDetails.car_color_v, car_engine: cardDetails.car_engine, car_privod: cardDetails.car_privod}"
      ></Overview> 
      <Features
          :languageEng="languageEng" :data="{car_people: cardDetails.car_people, car_transmission: cardDetails.car_transmission, car_doors: cardDetails.car_doors, car_power: cardDetails.car_power}"
      ></Features>
    </div>
    <div class="section --s-with-line">
     <Reviews v-if="cardReviews.length "
        :languageEng="languageEng" :data="cardReviews"
      ></Reviews> 
    </div>
    <div class="section"> 
      <h3 class="section-title-h3">{{ languageEng ? 'Choose a payment method' : 'Выберите метод оплаты'}}</h3>
      <ul class="payment">
        <li class="payment__item"  @click="Store.dispatch('UI/changePopupFormIsOpen', true)">
          <svg width="60" height="43" viewBox="0 0 60 43" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M28.9803 12.7393C28.9803 13.2516 29.2004 14.0062 31.1031 14.6404C31.9113 14.9097 34.3706 15.7295 34.3706 18.1295C34.3706 19.7888 33.2203 21.1837 31.6755 21.5607V21.9192C31.6755 22.3815 31.3008 22.7561 30.8386 22.7561C30.3763 22.7561 30.0016 22.3815 30.0016 21.9192V21.5607C28.4567 21.1837 27.3064 19.7888 27.3064 18.1295C27.3064 17.6672 27.6812 17.2926 28.1434 17.2926C28.6056 17.2926 28.9803 17.6672 28.9803 18.1295C28.9803 19.1543 29.8139 19.9878 30.8386 19.9878C31.8632 19.9878 32.6967 19.1542 32.6967 18.1295C32.6967 17.5393 32.4445 16.8519 30.5739 16.2284C28.4057 15.5057 27.3064 14.3318 27.3064 12.7393C27.3064 11.0801 28.4567 9.68522 30.0016 9.30826V8.94971C30.0016 8.48738 30.3763 8.11277 30.8386 8.11277C31.3008 8.11277 31.6755 8.48738 31.6755 8.94971V9.30826C33.2203 9.68522 34.3706 11.0801 34.3706 12.7393C34.3706 13.2016 33.9958 13.5762 33.5336 13.5762C33.0714 13.5762 32.6967 13.2016 32.6967 12.7393C32.6967 11.7146 31.8631 10.8812 30.8386 10.8812C29.814 10.8812 28.9803 11.7146 28.9803 12.7393ZM60 0.836943V30.0319C60 30.4942 59.6253 30.8688 59.1631 30.8688H58.3229V35.6564C58.3229 35.8928 58.2229 36.1182 58.0478 36.2769C57.8931 36.4168 57.6926 36.4934 57.486 36.4934C57.4585 36.4934 57.4309 36.4921 57.4032 36.4893L54.9687 36.2476V41.5147C54.9687 41.7677 54.8544 42.007 54.6576 42.1659C54.5074 42.2872 54.3214 42.3517 54.1318 42.3517C54.0731 42.3517 54.014 42.3454 53.9555 42.3329L0.670001 30.8521C0.66855 30.8517 0.667211 30.8515 0.66576 30.8512L0.660739 30.8501C0.648129 30.8474 0.636077 30.8436 0.62369 30.8403C0.614205 30.8379 0.604496 30.8358 0.595122 30.833C0.583628 30.8295 0.572469 30.8253 0.561087 30.8214C0.556958 30.8199 0.552717 30.8185 0.548588 30.8169C0.540219 30.8139 0.531738 30.8113 0.52348 30.808C0.521471 30.8072 0.519574 30.8063 0.517566 30.8055C0.507411 30.8013 0.497479 30.7964 0.487547 30.7918C0.477057 30.787 0.466456 30.7827 0.45619 30.7774C0.453623 30.7761 0.451168 30.7745 0.448601 30.7731C0.448267 30.7729 0.447932 30.7727 0.447486 30.7725C0.438 30.7675 0.42885 30.7621 0.419587 30.7568C0.410325 30.7514 0.400951 30.7465 0.392024 30.7408C0.387784 30.7381 0.383766 30.7351 0.379526 30.7323C0.37138 30.7271 0.363456 30.7214 0.355533 30.7159C0.34761 30.7103 0.339464 30.7049 0.331764 30.699C0.326408 30.6949 0.321275 30.6906 0.31603 30.6863C0.308999 30.6808 0.302081 30.6751 0.295273 30.6693C0.28869 30.6636 0.281994 30.658 0.275522 30.6522C0.269272 30.6466 0.263358 30.6406 0.257332 30.6348C0.251306 30.629 0.24528 30.6234 0.239477 30.6175C0.234232 30.612 0.229099 30.6066 0.223966 30.6011C0.217159 30.5937 0.210575 30.586 0.203991 30.5783C0.198858 30.5724 0.193501 30.5668 0.188591 30.5608C0.184574 30.5559 0.180891 30.5508 0.176986 30.5457C0.17029 30.5371 0.163929 30.5283 0.157568 30.5195C0.153216 30.5134 0.148418 30.5077 0.144177 30.5014C0.14083 30.4964 0.137928 30.4912 0.13458 30.486C0.128554 30.4768 0.122863 30.4674 0.117172 30.4578C0.113155 30.451 0.108803 30.4443 0.105008 30.4373C0.101549 30.4309 0.0983129 30.4246 0.0949651 30.4182C0.090613 30.4099 0.0864841 30.4016 0.0824668 30.3931C0.0786726 30.3853 0.0749901 30.3773 0.0714191 30.3694C0.0680714 30.3619 0.0648352 30.3544 0.0617106 30.3468C0.0588092 30.3397 0.056131 30.3327 0.0534528 30.3256C0.0499934 30.3163 0.0468688 30.307 0.0437442 30.2977C0.0408428 30.2892 0.0379414 30.2808 0.0353748 30.2721C0.0337009 30.2665 0.0321386 30.261 0.0305763 30.2554C0.0274517 30.2443 0.0249967 30.2331 0.0224301 30.2218C0.0203098 30.2127 0.0178548 30.2038 0.0160693 30.1947C0.0152882 30.1908 0.0146186 30.1867 0.0138375 30.1828C0.0112708 30.1687 0.00948535 30.1542 0.00769988 30.1397C0.00658395 30.1312 0.00502166 30.1229 0.00412892 30.1143C0.00390573 30.1122 0.00379414 30.1102 0.00357096 30.1082C0.00133911 30.0831 0 30.0576 0 30.0319V0.836943C0 0.374616 0.374727 0 0.836943 0H59.1631C59.6253 0 60 0.374616 60 0.836943ZM50.478 29.1949C50.8744 25.0503 54.1815 21.7432 58.3261 21.3468V9.52184C54.1815 9.12547 50.8744 5.81843 50.478 1.67377H9.52196C9.12558 5.81854 5.81854 9.12558 1.67389 9.52184V21.3468C5.81854 21.7432 9.12558 25.0503 9.52196 29.1949H50.478ZM7.83769 29.1949C7.45493 25.9744 4.89444 23.4139 1.67389 23.0311V29.1949H7.83769ZM7.83769 1.67389H1.67389V7.83769C4.89444 7.45482 7.45493 4.89444 7.83769 1.67389ZM58.3261 1.67389H52.1623C52.5451 4.89444 55.1056 7.45493 58.3261 7.83769V1.67389ZM53.2947 36.0814L15.4458 32.3233L53.2949 40.4782V36.0814H53.2947ZM56.649 30.8688H17.7368L56.649 34.7324V30.8688V30.8688ZM58.3261 29.1949V23.0311C55.1056 23.4139 52.5451 25.9744 52.1623 29.1949H57.4838C57.4845 29.1949 57.4853 29.1948 57.4859 29.1948C57.4866 29.1948 57.4874 29.1949 57.4881 29.1949H58.3261ZM38.7448 8.86367C38.3666 9.1296 38.2756 9.65163 38.5414 10.0297C39.6575 11.6173 40.2475 13.4862 40.2475 15.4343C40.2475 20.6224 36.0266 24.8433 30.8386 24.8433C25.6504 24.8433 21.4295 20.6224 21.4295 15.4343C21.4295 10.2463 25.6504 6.02543 30.8386 6.02543C32.7869 6.02543 34.6559 6.61542 36.2435 7.73168C36.6217 7.99783 37.1438 7.90677 37.4096 7.52847C37.6754 7.15039 37.5844 6.62837 37.2064 6.36244C35.3353 5.04699 33.1333 4.35155 30.8386 4.35155C24.7274 4.35155 19.7556 9.32332 19.7556 15.4343C19.7556 21.5454 24.7274 26.5171 30.8386 26.5171C36.9497 26.5171 41.9214 21.5454 41.9214 15.4343C41.9214 13.1397 41.2261 10.938 39.9107 9.06699C39.6451 8.68892 39.123 8.59808 38.7448 8.86367Z" fill="#E1E1E1"/>
          </svg>
          <span class="payment__item-name">{{ languageEng ? 'Cash' : 'Наличные'}}</span>
        </li>
        <li class="payment__item">
          <svg width="60" height="42" viewBox="0 0 60 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M43.125 25.3125V2.8125C43.125 1.26176 41.8632 0 40.3125 0H2.8125C1.26176 0 0 1.26176 0 2.8125V25.3125C0 26.8632 1.26176 28.125 2.8125 28.125H40.3125C41.8632 28.125 43.125 26.8632 43.125 25.3125ZM1.875 25.3125V2.8125C1.875 2.29559 2.29559 1.875 2.8125 1.875H40.3125C40.8294 1.875 41.25 2.29559 41.25 2.8125V25.3125C41.25 25.8294 40.8294 26.25 40.3125 26.25H2.8125C2.29559 26.25 1.875 25.8294 1.875 25.3125Z" fill="#E1E1E1"/>
            <path d="M57.1875 13.125H45.9375C45.4198 13.125 45 13.5448 45 14.0625C45 14.5802 45.4198 15 45.9375 15H57.1875C57.7044 15 58.125 15.4206 58.125 15.9375V20.625H45.9375C45.4198 20.625 45 21.0448 45 21.5625C45 22.0802 45.4198 22.5 45.9375 22.5H58.125V38.4375C58.125 38.9544 57.7044 39.375 57.1875 39.375H19.6875C19.1706 39.375 18.75 38.9544 18.75 38.4375V30.9375C18.75 30.4198 18.3302 30 17.8125 30C17.2948 30 16.875 30.4198 16.875 30.9375V38.4375C16.875 39.9882 18.1368 41.25 19.6875 41.25H57.1875C58.7382 41.25 60 39.9882 60 38.4375V15.9375C60 14.3868 58.7382 13.125 57.1875 13.125Z" fill="#E1E1E1"/>
            <path d="M19.6875 19.6875H15C14.4823 19.6875 14.0625 20.1073 14.0625 20.625C14.0625 21.1427 14.4823 21.5625 15 21.5625H19.6875C20.2052 21.5625 20.625 21.1427 20.625 20.625C20.625 20.1073 20.2052 19.6875 19.6875 19.6875Z" fill="#E1E1E1"/>
            <path d="M11.25 19.6875H6.5625C6.04477 19.6875 5.625 20.1073 5.625 20.625C5.625 21.1427 6.04477 21.5625 6.5625 21.5625H11.25C11.7677 21.5625 12.1875 21.1427 12.1875 20.625C12.1875 20.1073 11.7677 19.6875 11.25 19.6875Z" fill="#E1E1E1"/>
            <path d="M36.5625 19.6875H31.875C31.3573 19.6875 30.9375 20.1073 30.9375 20.625C30.9375 21.1427 31.3573 21.5625 31.875 21.5625H36.5625C37.0802 21.5625 37.5 21.1427 37.5 20.625C37.5 20.1073 37.0802 19.6875 36.5625 19.6875Z" fill="#E1E1E1"/>
            <path d="M28.125 19.6875H23.4375C22.9198 19.6875 22.5 20.1073 22.5 20.625C22.5 21.1427 22.9198 21.5625 23.4375 21.5625H28.125C28.6427 21.5625 29.0625 21.1427 29.0625 20.625C29.0625 20.1073 28.6427 19.6875 28.125 19.6875Z" fill="#E1E1E1"/>
            <path d="M10.3125 4.6875H7.5C5.94914 4.6875 4.6875 5.94926 4.6875 7.5V8.4375C4.6875 9.98824 5.94914 11.25 7.5 11.25H10.3125C11.8634 11.25 13.125 9.98824 13.125 8.4375V7.5C13.125 5.94926 11.8634 4.6875 10.3125 4.6875ZM11.25 8.4375C11.25 8.95441 10.8294 9.375 10.3125 9.375H7.5C6.98309 9.375 6.5625 8.95441 6.5625 8.4375V7.5C6.5625 6.98309 6.98309 6.5625 7.5 6.5625H10.3125C10.8294 6.5625 11.25 6.98309 11.25 7.5V8.4375Z" fill="#E1E1E1"/>
            <path d="M34.6875 4.6875C33.5682 4.6875 32.5627 5.18098 31.875 5.96109C31.1873 5.18098 30.1818 4.6875 29.0625 4.6875C26.9947 4.6875 25.3125 6.36973 25.3125 8.4375C25.3125 10.5053 26.9947 12.1875 29.0625 12.1875C30.1818 12.1875 31.1873 11.694 31.875 10.9139C32.5627 11.694 33.5682 12.1875 34.6875 12.1875C36.7553 12.1875 38.4375 10.5053 38.4375 8.4375C38.4375 6.36973 36.7553 4.6875 34.6875 4.6875ZM29.0625 10.3125C28.0287 10.3125 27.1875 9.47133 27.1875 8.4375C27.1875 7.40367 28.0287 6.5625 29.0625 6.5625C30.0963 6.5625 30.9375 7.40367 30.9375 8.4375C30.9375 9.47133 30.0963 10.3125 29.0625 10.3125ZM34.6875 10.3125C33.6537 10.3125 32.8125 9.47133 32.8125 8.4375C32.8125 7.40367 33.6537 6.5625 34.6875 6.5625C35.7213 6.5625 36.5625 7.40367 36.5625 8.4375C36.5625 9.47133 35.7213 10.3125 34.6875 10.3125Z" fill="#E1E1E1"/>
            <path d="M45.9375 18.75H56.25C56.7677 18.75 57.1875 18.3302 57.1875 17.8125C57.1875 17.2948 56.7677 16.875 56.25 16.875H45.9375C45.4198 16.875 45 17.2948 45 17.8125C45 18.3302 45.4198 18.75 45.9375 18.75Z" fill="#E1E1E1"/>
            <path d="M53.4375 30H35.625C35.1073 30 34.6875 30.4198 34.6875 30.9375C34.6875 31.4552 35.1073 31.875 35.625 31.875H53.4375C53.9552 31.875 54.375 31.4552 54.375 30.9375C54.375 30.4198 53.9552 30 53.4375 30Z" fill="#E1E1E1"/>
            <path d="M53.4375 33.75H42.1875C41.6698 33.75 41.25 34.1698 41.25 34.6875C41.25 35.2052 41.6698 35.625 42.1875 35.625H53.4375C53.9552 35.625 54.375 35.2052 54.375 34.6875C54.375 34.1698 53.9552 33.75 53.4375 33.75Z" fill="#E1E1E1"/>
          </svg>
          <span class="payment__item-name payment__item-name--no-access">{{ languageEng ? 'Not available' : 'Не доступно'}}</span>
        </li>
      </ul>
    </div>

    <template v-if="isOpenPayment">
      <Teleport to="#popup-form">
        <PaymentsFormsController :languageEng="languageEng"/>
      </Teleport>
    </template>
  </div>
</template>


<script>
import {defineComponent, reactive, computed, ref} from "vue";
import {useStore} from "vuex";
// Компонетны
// import PlanSelect from "@/components/planSelect/PlanSelect";
import Rating from "@/components/rating/Rating";
import SelectMiniatureWithTitleCalendar from "@/components/forms/components/selectMiniatureWithTitle/SelectMiniatureWithTitleCalendar";
import Overview from "@/components/overview/Overview";
import Features from "@/components/features/Features";
import Reviews from "@/components/reviews/Reviews";
// Forms  
import PaymentsFormsController from "@/components/forms/payment/paymentFormsController/paymentsFormsController";
import {getTodayDate} from "@/utills/date";
import {useRoute} from "vue-router";

export default  defineComponent({
  name : 'Car Info',
  components : {
    Reviews,
    Overview,
    Rating, SelectMiniatureWithTitleCalendar,
    Features, PaymentsFormsController,
  },
  props: {
    isMobile: {
      type : Boolean
    },
    languageEng:  { 
      type: Boolean 
    }
  },
  validate({ params }) {
    return /^\d+$/.test(params.id);
  },
  setup(props) {

    const Store = useStore();
    const route = useRoute()
    const isOpenPayment = computed(() => Store.getters['UI/popupFormIsOpen']);

    const rent_day = ref(false)

    const rent_weeks = ref(false)

    const rent_mouth = ref(false)

    const bad_date = ref(false)

    let rent_price = ''

   

    function changeDate() { 
      let date_form = another.trip_start.match(/\d\d\d\d-\d\d-\d\d/)[0]
      let date_form_date = new Date(another.trip_start.match(/\d\d\d\d-\d\d-\d\d/)[0].replace(/'-'/gi, '.'))

      let date_to_date = new Date(another.trip_end.match(/\d\d\d\d-\d\d-\d\d/)[0].replace(/'-'/gi, '.'))


      let date_res = (date_to_date - date_form_date) / (60 * 60 * 24 * 1000)

      if(date_res < 1) {
        bad_date.value = true
        rent_price = 0
        disabledButton.value = true
        rent_day.value = false
        rent_weeks.value = false
        rent_mouth.value = false
      }
      else if(date_res <= 3) {
        bad_date.value = false
        rent_price = computed(() => Store.getters['cars/getCarPriceOne'])
        disabledButton.value = false
        rent_day.value = true
        rent_weeks.value = false
        rent_mouth.value = false
      }
      else if(date_res > 3 && date_res < 8 && date_res < new Date(date_form.match(/\d\d\d\d/)[0], date_form[5] + date_form[6], 0).getDate()) {
        rent_price = computed(() => Store.getters['cars/getCarPriceTwo'])
        disabledButton.value = false
        rent_weeks.value = true
        rent_day.value = false
        bad_date.value = false
        rent_mouth.value = false
      } 
      else if(date_res >= 8) {
        rent_price = computed(() => Store.getters['cars/getCarPriceThree'])
        disabledButton.value = false
        rent_mouth.value = true
        bad_date.value = false
        rent_day.value = false
        rent_weeks.value = false
      }

    }
    
    const rentAuto = () => {
      Store.dispatch('UI/changePopupFormIsOpen', true)
      Store.commit('forms/setDate', {date: another.trip_start.replace(/T/, ' ') + ' - ' + another.trip_end.replace(/T/, ' ')})
      Store.commit('forms/setPrice', rent_price)
    }

    const another = reactive({
       trip_start: Store.getters['forms/getMainDateStart'] ? Store.getters['forms/getMainDateStart'] : getTodayDate(),
      trip_end : Store.getters['forms/getMainDateEnd'] ? Store.getters['forms/getMainDateEnd'] : getTodayDate(),
    }) 

    const carStatus = reactive({
      stars: [],

    })

    const disabledButton = ref(true)  
    let count;
    const fetchCarById = async () => {
      await Store.dispatch('cars/fetCarById',route.params.id)
      count = Store.getters['cars/getCar'].car_status
      for(let i = 0; i < +count; i++) {
        carStatus.stars.push({star: true})
      }
    }
    fetchCarById()
    const fetchReviews = async () => {
      await Store.dispatch('cars/fetReviews',route.params.id)
    }
    fetchReviews()
    const cardDetails = computed(() => Store.getters['cars/getCar'])
    const cardReviews = computed(() => Store.getters['cars/getReviews'])

    changeDate()


    return {
      another,
      isOpenPayment,
      Store,
      cardDetails,
      rentAuto,
      cardReviews,
      changeDate,
      disabledButton,
      rent_day,
      rent_weeks,
      rent_mouth,
      carStatus,
      bad_date,
      props
    }
  }
})
</script>

<style scoped src="../assets/styles/carInfo.css">

</style>


